import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getShiftJobOffers, acceptShiftJobOffer, declineShiftJobOffer, } from "../slice/workerResumeSlice";
import { useNavigate, Link } from "react-router-dom";

const WorkerShiftJobRequest = () => {

  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const { shiftJobOffers, loading, error } = useSelector(
    (state) => state.workerResume
  );

  useEffect(() => {
    if (!token) return;
    dispatch(getShiftJobOffers(token));
  }, [token, dispatch]);

  const handleAccept = (offerId) => {
    dispatch(acceptShiftJobOffer({ offerId, token }));
    dispatch(getShiftJobOffers(token));
  };

  const handleDecline = (offerId) => {
    dispatch(declineShiftJobOffer({ offerId, token }));
    dispatch(getShiftJobOffers(token));
  };

  // console.log("shiftJobOffers", shiftJobOffers);

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "accepted":
        return "bg-success";
      case "declined":
        return "bg-warning text-dark";
      default:
        return "bg-secondary";
    }
  };

  return (
    <>
      <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-3 border-bottom">
            Shift Request Offers
          </h4>

          {/* 🔄 Loading */}
          {loading && (
            <div className="d-flex justify-content-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          {/* ❌ Error */}
          {!loading && error && (
            <div className="alert alert-danger text-center">
              {error}
            </div>
          )}

          {/* ✅ Shift Cards */}
          {!loading && !error && (
            shiftJobOffers.length > 0 ? (
              shiftJobOffers.map((offer) => (
                <div className="card shadow-sm mb-4 border-0 rounded-3" key={offer.id}>
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-center">
                      {/* Title */}
                      <h5 className="text-primary fw-bold mb-3" style={{ fontSize: "1.25rem" }}>
                        {offer.title || "Shift Job Request"}
                      </h5>

                      <p>
                        <span className={`badge ${getStatusClass(offer.status)} text-uppercase`}>{offer.status}</span>
                      </p>

                    </div>

                    {/* Location */}
                    <p className="mb-3">
                      <strong className="me-2">📍 Location:</strong>
                      <span className="text-dark">{offer.city}, {offer.state}, {offer.country}</span>
                    </p>

                    {/* Salary */}
                    <p className="mb-3">
                      <strong className="me-2">💰 Salary Range:</strong>
                      <span className="text-dark">${offer.salary_min} - ${offer.salary_max}</span>
                    </p>

                    {/* Salary Type / Ratio */}
                    <p className="mb-3">
                      <strong className="me-2">⚖️ Salary Type:</strong>
                      <span className="badge bg-info text-dark">{offer.ratio || "Hourly"}</span>
                    </p>

                    {/* Dates */}
                    <p className="mb-3">
                      <strong className="me-2">📅 Date:</strong>
                      <span className="text-dark">
                        {offer.start_date}{offer.end_date && ` - ${offer.end_date}`}
                      </span>
                    </p>

                    {/* Timings */}
                    <p className="mb-3">
                      <strong className="me-2">🕒 Working Timings:</strong>
                      <span className="text-dark">
                        {offer.start_time}{offer.end_time && ` - ${offer.end_time}`}
                      </span>
                    </p>
                    <button
                        className="btn btn-light-header"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/panel/shift-request-details/${offer.id}`)
                        }}
                    >
                        Details
                    </button>
                    {offer.status?.toLowerCase() === "offered" && (
                      <div className="d-flex gap-3 mt-3">
                        <button
                          className="btn btn-success"
                          disabled={loading}
                          onClick={() => handleAccept(offer.id)}
                        >
                          Accept
                        </button>

                        <button
                          className="btn btn-outline-danger"
                          disabled={loading}
                          onClick={() => handleDecline(offer.id)}
                        >
                          Decline
                        </button>
                      </div>
                    )}

                  </div>
                </div>
              ))
            ) : (
              <p className="text-muted text-center">
                No shift job offers found.
              </p>
            )
          )}
        </div>
      </div>


    </>
  );
};

export default WorkerShiftJobRequest;
